import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';

import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { AgmCoreModule } from '@agm/core';
import { MatRadioModule } from '@angular/material/radio';
import { AgmSnazzyInfoWindowModule } from '@agm/snazzy-info-window';
import { MatSelectModule } from '@angular/material/select';
import { Page404Component } from './page404/page404.component';
import { NgbdCarouselBasic } from './portada/carousel-basic.component';
import { NovedadesComponent } from './novedades/novedades.component';
import { ServiciosComponent } from './servicios/servicios.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';

import { ArticuloComponent } from './articulo/articulo.component';

import { ContactosComponent } from './contactos/contactos.component';
import { HeaderComponent } from './shared/header/header.component';
import { MetodologiaComponent } from './metodologia/metodologia.component';


@NgModule({
  declarations: [

    AppComponent,
    HomeComponent,
    Page404Component,
    NovedadesComponent,
    NgbdCarouselBasic,
    ContactosComponent,
    ServiciosComponent,
    ArticuloComponent,
    HeaderComponent,
    MetodologiaComponent

  ],
  imports: [

   
    ReactiveFormsModule,
    HttpClientModule,
    BrowserModule.withServerTransition({ appId: 'serverApp' }), NgbModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    FormsModule,
    FontAwesomeModule,
    MatSidenavModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatSelectModule,
    MatRadioModule,
    MatMenuModule,
    LoadingBarHttpClientModule,
    LoadingBarRouterModule,
    LoadingBarModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDP4EEQY4d38nCW6BGv0X-ZUMmEJf75WZY',
      language: 'es',
      libraries: ['geometry', 'places']
    }),
    AgmSnazzyInfoWindowModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
